"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWindowVisibility = exports.getBrowserDocumentHiddenProp = exports.getBrowserVisibilityProp = void 0;
function getBrowserVisibilityProp() {
    if (typeof document === "undefined") {
        return "";
    }
    if ("msHidden" in document) {
        return "msvisibilitychange";
    }
    if ("webkitHidden" in document) {
        return "webkitvisibilitychange";
    }
    return "visibilitychange";
}
exports.getBrowserVisibilityProp = getBrowserVisibilityProp;
function getBrowserDocumentHiddenProp() {
    if (typeof document === "undefined") {
        return "";
    }
    if ("msHidden" in document) {
        return "msHidden";
    }
    if ("webkitHidden" in document) {
        return "webkitHidden";
    }
    return "hidden";
}
exports.getBrowserDocumentHiddenProp = getBrowserDocumentHiddenProp;
function getWindowVisibility() {
    if (typeof document === "undefined") {
        return false;
    }
    // @ts-ignore
    return !document[getBrowserDocumentHiddenProp()];
}
exports.getWindowVisibility = getWindowVisibility;
//# sourceMappingURL=cssUtils.js.map